import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';

import InputSearch from "../../ui/InputSearch/InputSearch";
import Arrows from "../../ui/Arrows/Arrows";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import ClientItem from "./ClientItem/ClientItem";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  changeClientsPage,
  changeClientsLimit,
  getClientsListAsync,
  changeClientsSearch,
  startClientsSearch,
  clearClientsSearch,
  changeClientsSorting,
} from "../../../redux/actions/clientsList";

import { setListsPayload } from '../../../methods';

const mapStateToProps = state => ({
  ...state.clientsList,
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changeClientsPage(page)),
  onChangeDisplayOption: limit => dispatch(changeClientsLimit(limit)),
  getClientsList: payload => dispatch(getClientsListAsync(payload)), 
  changeClientsSearch: value => dispatch(changeClientsSearch(value)),
  startClientsSearch: (value) => dispatch(startClientsSearch(value)),
  clearClientsSearch: () => dispatch(clearClientsSearch()),
  changeClientsSorting: (sort, order) => dispatch(changeClientsSorting(sort, order)),
});

class ClientsList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    clients: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    getClientsList: PropTypes.func.isRequired,
    //Поиск
    changeClientsSearch: PropTypes.func.isRequired,
    startClientsSearch: PropTypes.func.isRequired,
    clearClientsSearch: PropTypes.func.isRequired,
    search: PropTypes.string.isRequired,
    activeSearch: PropTypes.string.isRequired,
    //Сортировка
    changeClientsSorting: PropTypes.func.isRequired,
    sorting: PropTypes.object.isRequired,
  };

  componentDidMount = () => { 
    const { getClientsList, limit, activePage, activeSearch, sorting } = this.props;
    const payload = setListsPayload(limit, activePage, activeSearch, sorting);
    getClientsList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, activeSearch, sorting, getClientsList } = this.props;
    const payload = setListsPayload(limit, activePage, activeSearch, sorting);
    //Условия перезагрузки
    if (
      (previousProps.activePage !== activePage)
      || (previousProps.limit !== limit)
      || ((previousProps.activeSearch !== activeSearch))
      || ((previousProps.sorting.sort !== sorting.sort))
      || ((previousProps.sorting.order !== sorting.order))
    ) getClientsList(payload);
  }

  //ПОИСК
  //Для клиентов поиск ведется по имени и фамилии
  //Оставляем все символы
  onChangeClientsSearch = (value) => {
    const { changeClientsSearch, clearClientsSearch } = this.props;
    (value.length !== 0) ? changeClientsSearch(value) : clearClientsSearch();
  }

  startClientsSearching = (value) => {
    const { search, startClientsSearch } = this.props;
    //В строке поиска должен быть хотя бы один символ
    if ((value === 'Enter') && (search.length !== 0)){
      startClientsSearch(search);
    }
  }

  //СОРТИРОВКА
  onChangeClientsSorting = sortOption => {
    const { sorting, changeClientsSorting } = this.props;
    let order = true;
    if (sorting.sort === sortOption) order = !sorting.order;
    changeClientsSorting(sortOption, order);
  }

  renderClientsList = (item, i) => {
    return(
      <ClientItem key={`${item.id}_${i}`} client={item} /> 
    );
  }

  render() {
    const {
      ready, loading, clients, limit, sorting, total, activePage, onChangePage, onChangeDisplayOption,
      search, clearClientsSearch,
    } = this.props;

  //Классы для сортировки
  const nameClass = classnames({
    'header-item': true,
    'name': true,
    'current': sorting.sort === 'last_name',
  });

  const phoneClass = classnames({
    'header-item': true,
    'phone': true,
    'current': sorting.sort === 'phone',
  });

  const emailClass = classnames({
    'header-item': true,
    'email': true,
    'current': sorting.sort === 'email',
  });

  const dateClass = classnames({
    'header-item': true,
    'date': true,
    'current': sorting.sort === 'created_at',
  });

  const consultClass = classnames({
    'header-item': true,
    'consult-id': true,
    'current': sorting.sort === 'consultant_id', 
  });

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

    return(
      <div className="lists-wrap">
        <div className="lists-header">
          <InputSearch
            placeholder="Поиск по имени и фамилии"
            value={search}
            onChange={this.onChangeClientsSearch}
            onKeyUp={this.startClientsSearching}
            onClear={clearClientsSearch}
          />
        </div>
        {ready ? (
          <React.Fragment>
            <div className="lists-content">
              <div className="lists-content-total">Клиенты ({total})</div>
              <div className="list-header">
                <button
                    type="button"
                    className={nameClass}
                    onClick={() => this.onChangeClientsSorting('last_name')}
                >
                  Имя
                  <Arrows
                    sortUp={(sorting.sort === 'last_name') && (sorting.order)}
                    sortDown={(sorting.sort === 'last_name') && (!sorting.order)}
                  />
                </button>
                <button
                  type="button"
                  className={phoneClass}
                  onClick={() => this.onChangeClientsSorting('phone')}
                >
                  Номер телефона
                  <Arrows
                    sortUp={(sorting.sort === 'phone') && (sorting.order)}
                    sortDown={(sorting.sort === 'phone') && (!sorting.order)}
                  />
                </button>
                <button
                  type="button"
                  className={emailClass}
                  onClick={() => this.onChangeClientsSorting('email')}
                >
                  E-mail
                  <Arrows
                    sortUp={(sorting.sort === 'email') && (sorting.order)} 
                    sortDown={(sorting.sort === 'email') && (!sorting.order)}
                  />
                </button>
                <div className="header-item address">Адрес</div>
                <button
                  type="button"
                  className={dateClass}
                  onClick={() => this.onChangeClientsSorting('created_at')}
                >
                  <div>Дата</div> 
                  <div className="div-wrap">
                    регистрации
                    <Arrows
                      sortUp={(sorting.sort === 'created_at') && (sorting.order)}
                      sortDown={(sorting.sort === 'created_at') && (!sorting.order)}
                    />
                  </div>
                </button>
                <button
                  type="button"
                  className={consultClass}
                  onClick={() => this.onChangeClientsSorting('consultant_id')}
                >
                  Консультант
                  <Arrows
                    sortUp={(sorting.sort === 'consultant_id') && (sorting.order)}
                    sortDown={(sorting.sort === 'consultant_id') && (!sorting.order)}
                  />
                </button>
              </div>
              {clients.length !== 0 ? clients.map(this.renderClientsList) : false}
            </div>
            <div className="lists-footer">
              {clients.length !== 0 ? (
                <PaginationBlock
                  activePage={activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[15, 30, 60, 120]}
                  selectedDisplayOption={limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
                ) : false}
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(ClientsList));
